import { AngularFireAuth } from "@angular/fire/compat/auth";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { EncryptionService } from './encryption.service';
// utils function
import { requestToken } from "../../utils/auth.utils";

@Injectable({
    providedIn: "root",
})

export class PaymentService {

    private apiUrl = 'https://rqx436nj0g.execute-api.us-west-1.amazonaws.com/generate_payment_link'; // 
    eventData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    userCurrentTime: any;
    userExpirationTime: any;
    refToken: any;
    encryptedData: any;
    decryptedData: any;
    private userSubject = new BehaviorSubject<any>(null);
    public user$ = this.userSubject.asObservable();
    constructor(private http: HttpClient, private afAuth: AngularFireAuth, private encryptionService: EncryptionService) { }

    /**
     * Fetch products from Lemon Squeezy
     * @returns Observable with products list
     */
    async fetchLemonSqueezyProducts() {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        const token: any = user?.stsTokenManager.accessToken;

        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);

        if (this.userCurrentTime < this.userExpirationTime) {
            const headers = new HttpHeaders()
                .set("Content-Type", "application/json")
                .set("Authorization", token);

            return this.http.get(
                "https://p1mphhpkj7.execute-api.us-west-1.amazonaws.com/dev/pwa-fetch-lemonsqueezy-products",
                { headers }
            );
        } else {
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                this.refToken = Reftoken;
            }

            const headers = new HttpHeaders()
                .set("Content-Type", "application/json")
                .set("Authorization", this.refToken);

            return this.http.get(
                "https://p1mphhpkj7.execute-api.us-west-1.amazonaws.com/dev/pwa-fetch-lemonsqueezy-products",
                { headers }
            );
        }
    }

    /**
     * Generate Lemon Squeezy payment link
     * @param variant_id Lemon Squeezy variant ID
     * @param product_name Product name
     * @param custom_data Custom data object
     * @param promo_code Optional promo code
     * @returns Observable with checkout URL
     */
    async generateLemonSqueezyPaymentLink(variant_id: string, product_name: any, custom_data: any, promo_code?: string) {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        const token: any = user?.stsTokenManager.accessToken;

        // Check token expiration
        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);

        // Set headers and make request
        if (this.userCurrentTime < this.userExpirationTime) {
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token);

            let params = new HttpParams()
                .set("variant_id", variant_id)
                .set("product_name", product_name)
                .set("custom_data", JSON.stringify(custom_data));

            if (promo_code) {
                params = params.set("promo_code", promo_code);
            }

            return this.http.post(
                "https://gwcnm89m9g.execute-api.us-west-1.amazonaws.com/dev/pwa-get-lemonsqueezy-checkout-url",
                params.toString(),
                { headers }
            );

        } else {
            // Refresh token if expired
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                this.refToken = Reftoken;
            }

            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", this.refToken);

            let params = new HttpParams()
                .set("variant_id", variant_id)
                .set("product_name", 'Premium')
                .set("custom_data", JSON.stringify(custom_data));

            if (promo_code) {
                params = params.set("promo_code", promo_code);
            }

            return this.http.post(
                "https://gwcnm89m9g.execute-api.us-west-1.amazonaws.com/dev/pwa-get-lemonsqueezy-checkout-url",
                params.toString(),
                { headers }
            );
        }
    }

    // generatePaymentLink(userId: string, numberOfEvents: number): Observable<PaymentLinkResponse> {

    //     return this.http.post<PaymentLinkResponse>(this.apiUrl, {
    //         user_id: userId,
    //         number_of_events: numberOfEvents,
    //         price_id: 'price_1HKiSf2eZvKYlo2CxjF9qwbr', // Replace with your Price ID for events
    //     });
    // }


    async generatePaymentLink(price_id: string) {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        const token: any = user?.stsTokenManager.accessToken;
        // Add for AccessToken get
        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);
        // set headers
        if (this.userCurrentTime < this.userExpirationTime) {
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token)

            const params = new HttpParams()
                //.set("number_of_events", numberOfEvents)
                .set("price_id", price_id);

            return this.http.post(
                "https://rqx436nj0g.execute-api.us-west-1.amazonaws.com/generate_payment_link",
                params.toString(),
                { headers }
            );

        } else {
            // call utils function for token request
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                //   console.log(Reftoken);  
                this.refToken = Reftoken;
            }
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", this.refToken)

            const params = new HttpParams()
                //.set("number_of_events", numberOfEvents)
                .set("price_id", price_id);

            return this.http.post(
                "https://rqx436nj0g.execute-api.us-west-1.amazonaws.com/generate_payment_link",
                params.toString(),
                { headers }
            );
        }
    }


    // getPaymentStatus(sessionId: string): Observable<any> {
    //     this.encryptedData = localStorage.getItem('user');
    //     this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    //     const user = JSON.parse(this.decryptedData || "{}");
    //     const token: any = user?.stsTokenManager.accessToken;

    //     const headers = new HttpHeaders()
    //         .set("Content-Type", "application/x-www-form-urlencoded")
    //         .set("Authorization", token);

    //     return this.http.get(
    //         `https://rqx436nj0g.execute-api.us-west-1.amazonaws.com/payment_status/${sessionId}`,
    //         { headers }
    //     );
    // }

    /**
     * Fetch current subscription details for the logged-in user.
     * Returns status, billing amount/interval, next billing date and portal URLs.
     */
    async getSubscriptionDetails() {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || '{}');
        const token: any = user?.stsTokenManager?.accessToken;

        const expirationTime = user?.stsTokenManager?.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);

        const activeToken = (this.userCurrentTime < this.userExpirationTime)
            ? token
            : await requestToken(this.afAuth).then(t => { this.refToken = t; return t; });

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Authorization', activeToken);

        return this.http.get(
            'https://mxirmn56nj.execute-api.us-west-1.amazonaws.com/default/pwa-fetch-subscription-details',
            { headers }
        );
    }

    /**
     * Update the variant (plan) on the user's existing active subscription.
     * Calls the backend which does PATCH /v1/subscriptions/{id} on Lemon Squeezy.
     */
    async updateSubscriptionVariant(variantId: string) {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || '{}');
        const token: any = user?.stsTokenManager?.accessToken;

        const expirationTime = user?.stsTokenManager?.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);

        const activeToken = (this.userCurrentTime < this.userExpirationTime)
            ? token
            : await requestToken(this.afAuth).then(t => { this.refToken = t; return t; });

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Authorization', activeToken);

        return this.http.post(
            'https://7m1na3bly8.execute-api.us-west-1.amazonaws.com/default/pwa-update-lemonsqueezy-subscription',
            { variant_id: variantId },
            { headers }
        );
    }

    /**
     * Cancel the current user's subscription (cancels at end of billing period).
     */
    async cancelSubscription() {
        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || '{}');
        const token: any = user?.stsTokenManager?.accessToken;

        const expirationTime = user?.stsTokenManager?.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);

        const activeToken = (this.userCurrentTime < this.userExpirationTime)
            ? token
            : await requestToken(this.afAuth).then(t => { this.refToken = t; return t; });

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Authorization', activeToken);

        return this.http.post(
            'https://pxj2mho4vi.execute-api.us-west-1.amazonaws.com/default/pwa-cancel-subscription',
            {},
            { headers }
        );
    }

    loginWithCookie() {
        return this.http.get('/api/auth/me', { withCredentials: true }).pipe(
            tap((user: any) => this.userSubject.next(user)),
            catchError(() => {
                this.userSubject.next(null);
                return of(null);
            })
        );
    }


    getCookie(name: string): string | null {
        const matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([$?*|{}\]\\^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }
    async verifyToken(token: any) {
        // // const allCookies = document.cookie;
        // // const jwt = this.getCookie('jwt');
        // // console.log(jwt);
        // // const headers = new HttpHeaders().set('Authorization', jwt || '');
        // return this.http.get<any>('https://zts1uaygu8.execute-api.us-west-1.amazonaws.com/pwa_verify_token', { withCredentials: true }).pipe(
        //     tap((_user: any) => {
        //         // localStorage.setItem('jwt', token);
        //         this.userSubject.next(_user);
        //     }),
        //     catchError(error => {
        //         console.error('Token validation failed', error);
        //         return of(null);
        //     })
        // );

        // // Add for AccessToken get
        // const expirationTime = user?.stsTokenManager.expirationTime;
        // const currentTime = new Date().getTime() / 1000;
        // this.userCurrentTime = new Date(currentTime * 1000);
        // this.userExpirationTime = new Date(expirationTime);
        // if (this.userCurrentTime < this.userExpirationTime) {
        const options = {
            headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token)
        };
        return this.http.get(
            "https://zts1uaygu8.execute-api.us-west-1.amazonaws.com/pwa_verify_token",
            options
        );
        // } else {
        //     // call utils function for token request
        //     const Reftoken = await requestToken(this.afAuth);
        //     if (Reftoken) {
        //         //   console.log(Reftoken);  
        //         this.refToken = Reftoken;
        //     }
        //     const options = {
        //         headers: new HttpHeaders()
        //             .set("Content-Type", "application/x-www-form-urlencoded")
        //             .set("Authorization", this.refToken)
        //     };
        //     return this.http.get(
        //         "https://zts1uaygu8.execute-api.us-west-1.amazonaws.com/pwa_verify_token",
        //         options
        //     );
        // }

    }

}